import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/authStore';
import { initTheme } from './utils/theme';
import { ProtectedRoute } from './components/Auth/ProtectedRoute';
import { MainLayout } from './components/Layout/MainLayout';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Users } from './pages/Users';
import { Analytics } from './pages/Analytics';
import { Companies } from './pages/Companies';
import { Settings } from './pages/Settings';
import { Logs } from './pages/Logs';
import { Security } from './pages/Security';

function App() {
  const { initialize, user } = useAuthStore();

  useEffect(() => {
    initialize();
    initTheme();
  }, [initialize]);

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Rota pública */}
          <Route 
            path="/login" 
            element={
              user ? <Navigate to="/" replace /> : <Login />
            } 
          />
          
          {/* Rotas protegidas */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <Dashboard />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <Users />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/analytics"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <Analytics />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/companies"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <Companies />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <Settings />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/logs"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <Logs />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/security"
            element={
              <ProtectedRoute>
                <MainLayout>
                  <Security />
                </MainLayout>
              </ProtectedRoute>
            }
          />
          
          {/* Rota padrão - redirecionar para dashboard */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
